<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 md4 pr-4>
        <v-text-field label="Name" v-model="search.Name"></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field label="City" v-model="search.City"></v-text-field>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field label="County" v-model="search.County"></v-text-field>
      </v-flex>
    </v-layout>
    <v-card-actions class="mt-4">
      <v-spacer></v-spacer>
      <v-btn @click="search = {Name: '', City: '', County: ''}"  color="secondary">Clear</v-btn>
      <v-btn color="primary" @click="create">Add New Site</v-btn>
    </v-card-actions>
    <v-card class="mt-4" elevation="1">
      <v-data-table 
        :items="filtered" 
        :headers="headers"
        :rows-per-page-items="[10,25,50,100]"
      >
        <template slot="items" slot-scope="props">
          <tr style="text-align: left">
            <td>
              <v-btn icon color="primary" @click="edit(props.item)"><v-icon>edit</v-icon></v-btn>
              {{props.item.SiteInsitutionName}}
            </td>
            <td>{{props.item.Address1}}</td>
            <td>{{props.item.Address2}}</td>
            <td>{{props.item.City}}</td>
            <td>{{props.item.State}}</td>
            <td>{{props.item.Zip}}</td>
            <td>{{props.item.County}}</td>
            <td>
              <v-checkbox
                readonly
                :value="props.item.NotInUse"
              ></v-checkbox>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="850px"
    >
      <v-card>
        <v-card-title>{{dialogText}}</v-card-title>
        <v-card-text>
        <v-text-field
          label="Name"
          v-model="item.SiteInsitutionName"
        ></v-text-field>
        <v-text-field
          label="Address Line One"
          v-model="item.Address1"
        ></v-text-field>
        <v-text-field
          label="Address Line Two"
          v-model="item.Address2"
        ></v-text-field>
        <v-text-field
          label="City"
          v-model="item.City"
        ></v-text-field>
        <v-text-field
          label="County"
          v-model="item.County"
        ></v-text-field>
        <v-text-field
          label="State"
          v-model="item.State"
        ></v-text-field>
        <v-text-field
          label="Zip"
          v-model="item.Zip"
        ></v-text-field>
        <v-checkbox
          label="Inactive"
          v-model="item.NotInUse"
        ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="updateSiteAddress(item); dialog=false" v-if="item.ID > 0">Save</v-btn>
          <v-btn color="primary" @click="createSiteAddress(item); dialog=false" v-else>Create</v-btn>
          <v-btn color="secondary" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
const moduleNameSpace = 'siteAddress'
import appConfig from '@src/app.config'
export default {
  name: 'AdminFacility',
  data() {
    return {
      headers: [
        { text: 'Name', value: 'SiteInsitutionName' },
        { text: 'Address Line One', value: 'Address1' },
        { text: 'Address Line Two', value: 'Address2' },
        { text: 'City', value: 'City' },
        { text: 'State', value: 'State' },
        { text: 'Zip', value: 'Zip' },
        { text: 'County', value: 'County' },
        { text: 'Inactive', value: 'NotInUse' },
      ],
      search: {
        Name: '',
        City: '',
        County: '',
      },
      item: {},
      dialog: false,
      dialogText: ''
    }
  },
  created() {
    this.getSiteAddress()
  },
  methods: {
    ...mapActions(moduleNameSpace, ['getSiteAddress', 'updateSiteAddress', 'createSiteAddress']),
    edit(site){
      this.item = {
        ID: site.ID,
        SiteInsitutionName: site.SiteInsitutionName,
        Address1: site.Address1,
        Address2: site.Address2,
        City: site.City,
        State: site.State,
        Zip: site.Zip, 
        County: site.County,
        NotInUse: site.NotInUse
      }
      this.dialogText = `Edit Site:  ${site.SiteInsitutionName}`
      this.dialog = true
    },
    create(){
      this.item = {
        ID: 0,
        SiteInsitutionName: '',
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Zip: '', 
        County: '',
        NotInUse: false
      }
      this.dialogText = `Add New Site`
      this.dialog = true
    }
  },
  computed: {
    ...mapGetters(moduleNameSpace, ['siteAddress']),
    filtered(){
      const self = this
      let list = JSON.parse(JSON.stringify(this.siteAddress))
      if(this.search.Name || this.search.City || this.search.County){
        list = list.filter(i => {
          return (self.search.Name && i.SiteInsitutionName.toLowerCase().includes(self.search.Name.toLowerCase())) || (self.search.City && i.City.toLowerCase().includes(self.search.City.toLowerCase())) || (self.search.County && i.County.toLowerCase().includes(self.search.County.toLowerCase()))
        })
      }
      return list
    }
  },
}
</script>